<script lang="ts">
  import Section from '$components/common/Section.svelte';
</script>

<svelte:head>
  <title>Prêt Employeur La Poste pour un achat en BRS | Boris</title>
  <meta
    name="description"
    content="Découvrez la surbonification du Prêt Employeur La Poste pour les postiers de la maison mère qui achètent en BRS en Île-de-France ou dans les DROM." />
</svelte:head>

<Section
  title="Surbonification du Prêt Employeur La Poste"
  titleElement="h1">
  <p>
    <b>
      Vous achetez votre résidence principale en Bail Réel Solidaire (BRS) en
      Île-de-France ou dans les DROM ?
    </b>
  </p>
  <p>
    Si vous êtes postier·e et éligible au BRS, vous pouvez bénéficier de 50 000
    € de financement complémentaire avec une bonification de taux de 2,5 % par
    rapport au taux du marché. Cette aide renforce les avantages déjà offerts
    par le BRS pour concrétiser votre projet immobilier.
  </p>

  <iframe
    class="aspect-video"
    width="100%"
    src="https://drive.google.com/file/d/1_P_pdR_13dtJTywkyFKMRdG1ccYWDN1x/preview"
    title="Vidéo de présentation du Prêt Employeur La Poste pour un achat en BRS"
    frameborder="0"
    allow="autoplay; fullscreen"
    loading="lazy"
    allowfullscreen>
  </iframe>

  <h2 class="fr-mt-6w">À qui s’adresse ce dispositif ?</h2>
  <p>
    La bonification est réservée aux postiers salariés et fonctionnaires de la
    maison mère qui remplissent les deux conditions suivantes :
  </p>
  <ul>
    <li>
      réaliser une acquisition en BRS située en Île-de-France ou dans les DROM ;
    </li>
    <li>être éligible au BRS et au prêt à taux zéro (PTZ).</li>
  </ul>

  <h2 class="fr-mt-6w">Pourquoi bénéficier de cette bonification ?</h2>
  <p>
    En associant le BRS et le PTZ à la bonification du Prêt Employeur La Poste
    proposée par Action Logement Services, vous pouvez :
  </p>
  <ul>
    <li>réduire le coût de votre crédit ;</li>
    <li>payer moins d’intérêts sur votre financement ;</li>
    <li>renforcer votre capacité d’emprunt ;</li>
    <li>
      faciliter votre accès à la propriété en Île-de-France ou dans les DROM, où
      les prix immobiliers sont élevés.
    </li>
  </ul>

  <a
    class="fr-btn fr-btn--lg fr-my-2w"
    href="https://forms.office.com/r/egzrs3pFby"
    target="_blank"
    rel="noopener noreferrer">
    Solliciter le Service Logement du groupe La Poste pour vous accompagner dans
    vos démarches
  </a>

  <p class="fr-text--sm">
    <i>
      Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de
      remboursement avant de vous engager.
    </i>
  </p>
</Section>
